import React, {
  useCallback,
  useMemo,
} from 'react'

import PropTypes from 'prop-types'

import { useDisplayManager } from 'components/DisplayManager'
import { useTCF } from 'components/TCFProvider'

import DetailsHeader from '../../DetailsHeader'

import DetailSection from './DetailSection'
import Styles from './styles.scss'

import getDetailsSections from './lib/getDetailsSections'


export default function TCFDetailsContent({ currentStyle, selectedDetails }) {
  const { gvl } = useTCF()
  const { popActiveUI } = useDisplayManager()

  const detailsSections = useMemo(() => {
    return getDetailsSections({
      gvl,
      selectedDetails,
    })
  }, [gvl, selectedDetails])

  const handleBackClick = useCallback(() => {
    popActiveUI()
  }, [popActiveUI])

  return (
    <div className={ Styles.root }>
      <DetailsHeader
        currentStyle={ currentStyle }
        handleBackClick={ handleBackClick }
        title={ selectedDetails.name }
      />

      {
        detailsSections.map(({ content, header }, idx) => (
          <div
            className={ Styles.detailSection }
            key={ idx }
          >
            <DetailSection
              content={ content }
              header={ header }
            />
          </div>
        ))
      }
    </div>
  )
}

TCFDetailsContent.propTypes = {
  selectedDetails: PropTypes.shape({
    description: PropTypes.string,
    id: PropTypes.number,
    illustrations: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.string,
  }).isRequired,

  currentStyle: PropTypes.shape({
    color: PropTypes.string,
    font_family: PropTypes.string,
  }),
}
